import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Stitch: surface-container-lowest bg, no border, focus shifts to primary
          "flex h-10 w-full rounded-lg bg-[#000000] px-4 py-2 text-sm font-medium text-white placeholder:text-[#ababab]/50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#6bff8f] disabled:cursor-not-allowed disabled:opacity-50 transition-all",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
